<template>
  <div>
    <app-detail-header
      :title="'Approve IP Range Change Requests'"
    ></app-detail-header>
    <div class="row">
      <div class="col-lg-4 col-md-6 col-sm-12">
        <approveConfig></approveConfig>
      </div>
      <div class="col-lg-8 col-md-6 col-sm-12">
        <approvePanel></approvePanel>
      </div>
    </div>
  </div>
</template>
<script>
import ApproveIpRangesConfig from "../../components/paywall/users/ApproveIpRangesConfig";
import ApproveIpRangesPanel from "../../components/paywall/users/ApproveIpRangesPanel";
export default {
  data() {
    return {};
  },
  components: {
    approveConfig: ApproveIpRangesConfig,
    approvePanel: ApproveIpRangesPanel,
  },
};
</script>



// WEBPACK FOOTER //
// src/views/users/UserApproveIpRanges.vue